export default "__VITE_ASSET__BAwQ2JgX__"